import styled from 'styled-components'
import { Link }  from 'react-router-dom'

const Right = styled.div`
    padding:15px;

    transition: color 100ms ease;
    display:flex;
    font-size:1.5rem;
    flex-direction:column;
    align-items:center;
    justify-content:center;
        
`

const Heading = styled.h1`
transition: color 100ms ease;
    
`

const Wrapper = styled.div`
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
    cursor:pointer;
    background:white;
    border-radius:15px;

    &:hover ${Right} {
        color:${p=>p.theme.background.secondary};
    }

    &:hover  {
     color:#404e;
    }

    display:flex;
    justify-content:space-between;


`



const Description = styled.p`
    
`

const Body = styled.div`
    padding:15px;

`

const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;
`

const Heart = styled.em`
    color:${p=>p.isLove ? 'red' : 'black'};
    margin-bottom:10px;
    margin-left:5px;


    transition: color 150ms ease;
    &:hover {
        color: red;
    }
`


const Card = props => {

    const { label,description,categoryId, isProcess, processId,setLove,love = {},to,origin, user } = props;


    return (
        <StyledLink to={isProcess ? origin === 'admin' ? `/process/edit/${processId}` : `/${to}?processId=${processId}` : `?categoryId=${categoryId}`}>
        <Wrapper>
            <Body>
            <Heading>{label} { isProcess && user && <Heart isLove={love[processId]} className={`${love[processId] ? 'fas ' : 'fal '} fa-heart`} onClick={(e) => { e.preventDefault(); setLove(processId) }} />}</Heading>
            <Description>{description}</Description>
            </Body>
            <Right><em className="fal fa-chevron-right"/></Right>
        </Wrapper>
        </StyledLink>
    )

}

export default Card